var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1335 5.3329H9.13346V4.13956C9.13346 2.39956 7.86013 0.846229 6.1268 0.679562C5.66369 0.634782 5.19633 0.687291 4.7547 0.833722C4.31308 0.980153 3.90693 1.21727 3.56232 1.52987C3.21771 1.84247 2.94224 2.22365 2.75358 2.64895C2.56492 3.07425 2.7998 2.99951 2.2998 2.99951L3.80013 2.99956C4.2998 2.49951 4.20013 2.50623 4.89346 2.19956C6.3668 1.53956 7.80013 2.59956 7.80013 3.99956V5.3329H0.466797V14.6662H11.1335V5.3329ZM9.80013 13.3329H1.80013V6.66623H9.80013V13.3329ZM5.80013 11.3329C6.53346 11.3329 7.13346 10.7329 7.13346 9.99956C7.13346 9.26623 6.53346 8.66623 5.80013 8.66623C5.0668 8.66623 4.4668 9.26623 4.4668 9.99956C4.4668 10.7329 5.0668 11.3329 5.80013 11.3329Z",
    fill: "#272727"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.2cc41359.svg";
export { ForwardRef as ReactComponent };